// ========================================
// KCP Ingest List API Types
// ========================================

export interface KCPIngestMeta {
  id: number;
  source_content_type: string;
  content_type: string;
  status: string;
  enable: boolean;
  meta: any; // Original metadata JSON
  target_assets: string[];
}

export interface MediaHubMapping {
  content_type: string; // 'season' | 'content'
  id: number;
  slug: string;
  publish_status: string;
}

export interface KCPBasicInfo {
  id: number;
  title: string;
}

export interface KCPIngestItem {
  id: number; // ContentIngest ID
  source: string;
  file_path: string;
  status: string; // ingest status
  ingest_at: string;
  created: string;
  modified: string;
  meta: KCPIngestMeta;
  mediahub: MediaHubMapping | null;
  kcp: KCPBasicInfo;
  video: number; // UCMS Video ID
  video_asset_status: string;
  ingest_content_type_id: number;
  ingest_content_id: number;
}

export interface ContentIngestAsset {
  id: number;
  asset_type: string; // 'video' | 'poster' | 'thumbnail' | etc
  status: string; // 'ready' | 'processing' | 'success' | 'fail'
  created: string;
  modified: string;
}

export interface ContentIngestProcessing {
  id: number;
  processing: string;
  description: string | null;
  created: string;
}

export interface KCPIngestDetail extends KCPIngestItem {
  assets?: ContentIngestAsset[];
  processing?: ContentIngestProcessing[];
}

// ========================================
// KCP Info List API Types
// ========================================

export interface KCPInfoItem {
  id: number; // KCP Content ID
  title: string;
  source_content_type: string;
  content_type: string;
  mediahub: MediaHubMapping | null;
  status: string; // KCP status (active, inactive, delete)
  on_air_status: string | null;
  is_kocowa: boolean | null;
  start_date: string;
  end_date: string;
  file_path: string;
  content_ingest_id: number;
  created: string;
  modified: string;
}

// ========================================
// Enums
// ========================================

export enum KCPContentType {
  SERIES = 'series',
  SEASON = 'season',
  EPISODE = 'episode',
}

export enum IngestStatus {
  START = 'start',
  PROCESSING = 'processing',
  END = 'end',
}

export enum DeletionType {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETE = 'delete',
}

export type PublishStatus = 'draft' | 'published' | 'unpublished';

// ========================================
// Color Constants
// ========================================

export const INGEST_STATUS_COLORS: Record<string, string> = {
  start: 'blue',
  processing: 'green',
  end: 'gray',
};

export const KCP_STATUS_COLORS: Record<string, string> = {
  active: 'blue',
  inactive: 'default',
  delete: 'red',
};

export const VIDEO_STATUS_COLORS: Record<string, string> = {
  ready: 'blue',
  processing: 'green',
  success: 'gray',
  fail: 'red',
};

export const ASSET_STATUS_COLORS: Record<string, string> = {
  ready: 'blue',
  processing: 'green',
  success: 'gray',
  fail: 'red',
};

export const KCP_TYPE_COLORS: Record<string, string> = {
  series: 'purple',
  season: 'cyan',
  episode: 'orange',
};
